export default __webpack_public_path__ + "static/construction-5c81a3ff997bee481db3977dc029a8ec.jpg";